import React from 'react';
import { Alert, Button, Group } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface ConsentBannerProps {
  onCreateConsent: () => void;
}

export function ConsentBanner({ onCreateConsent }: ConsentBannerProps) {
  const { t } = useTranslation(['lims', 'common']);

  return (
    <Alert 
      icon={<IconAlertTriangle size={20} />} 
      color="yellow"
      mb="md"
      title={t('consent.bannerTitle', { ns: 'lims' })}
    >
      <Group justify="space-between" align="center">
        <span>
          {t('consent.noConsent', { ns: 'lims' })}
        </span>
        <Button 
          onClick={onCreateConsent}
          variant="filled"
          color="yellow"
          size="sm"
        >
          {t('consent.createButton', { ns: 'lims' })}
        </Button>
      </Group>
    </Alert>
  );
}
